const INITIAL_EVALUATION_FEE = 1
const MONTHLY_FEE = 2

export { INITIAL_EVALUATION_FEE, MONTHLY_FEE }
